import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateHunterEmailApiSettings } from '../../../redux/actions/apiSettings';
import Loader from '../../Loader';

const Hunter = ({ loading, emailApis }) => {
	const dispatch = useDispatch();
  const [disabledBtnConfirm, setDisabledBtnConfirm] = useState(false);
	const [hunterForm, setHunterForm] = useState({
		apiKey: '',
		approveForWebmail: false,
		type: 'hunter',
	});

  // console.log("The value is at this". hunterForm);
  
	useEffect(() => {
		if (emailApis?.hunter) {
			emailApis.hunter.type = 'hunter';
			setHunterForm(emailApis.hunter);
		}
	}, [emailApis]);
  useEffect(()=> {
    if (hunterForm?.apiKey?.length === 0 ) {
      setDisabledBtnConfirm(true);
      // console.log("The btn true vlaue:::===>>>", disabledBtnConfirm)
    } else {
      setDisabledBtnConfirm(false);
      // console.log("The btn false vlaue:::===>>>", disabledBtnConfirm)
    } 
  },[hunterForm])

	const handleHunterApiFrom = (e) => {
		e.preventDefault();
		if (hunterForm.apiKey.trim()) {
			dispatch(updateHunterEmailApiSettings(hunterForm));
		} else {
			toast.error('Please enter api key');
		}
	};

	return (
		<>
			{loading && <Loader />}
			<div id='tab-1' className='tab-content'>
				<div className='hunterTabContent'>
          <div className="contentInputWrapers">
            <p className='tabHeadingP'>Add Hunter API key</p>
            <input
                type='text'
                className='inputBox'
                placeholder='Enter your API key'
                value={hunterForm.apiKey}
                onChange={(e) =>
                  setHunterForm({ ...hunterForm, apiKey: e.target.value })
                }
              />
              {console.log("The value is at this". hunterForm)}
          </div>
					<div className='fieldWrapers tabsSec'>
						
						<span className='optionButton'>
            <span className='btntext'>Approve for webmail</span>
							<label className='switch'>
								<input
									type='checkbox'
									defaultChecked={hunterForm.approveForWebmail}
									className={hunterForm.approveForWebmail ? 'checked' : ''}
									onChange={(e) =>
										setHunterForm({
											...hunterForm,
											approveForWebmail: !hunterForm.approveForWebmail,
										})
									}
								/>
								<span className='slider round'></span>
							</label>{' '}
							
						</span>

						<button className='apiBtn' disabled={disabledBtnConfirm} onClick={handleHunterApiFrom}>
							Confirm
						</button>
            {}
					</div>
				</div>
			</div>
		</>
	);
};

export default Hunter;
